import { render, staticRenderFns } from "./ReadEditTextarea.vue?vue&type=template&id=4ccc9b79&scoped=true&"
import script from "./ReadEditTextarea.vue?vue&type=script&lang=ts&"
export * from "./ReadEditTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./ReadEditTextarea.vue?vue&type=style&index=0&id=4ccc9b79&scoped=true&lang=scss&"
import style1 from "./ReadEditTextarea.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc9b79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
